import Header from "../../components/Header/Header";
import React, { Fragment, useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import { Route, Switch } from "react-router-dom";
import { RoutedCustomCrumbs } from "../../components/BreadCrumbs";
import PaymentPopUp from "../Payment/PaymentPopUp";
import SmsLang from "../Sms-Lang";
import Packages from "../Packages";
import Home from "../Home";
import { useTranslation } from "react-i18next";
import buildInfo from "../../buildInfo.js";
import ErrorPopUp from "../../components/ErrorPopUp";
import PaymentReceipt from "../PaymentReceipt";
import { useTouristDocumentTitle } from "../../lib/useTouristDocumentTitle";

const Dashboard = (props) => {
	const {
		i18n,
		paymentInitializer,
		paymentInitData,
		paymentSubmit,
		paymentURL,
		getPaymentData,
		paymentDataAfterPayment,
		getBalanceUsage,
		getBalanceAmount,
		balanceUsageData,
		paypalInitData,
		getPaypalInit,
		getPackageBundles,
		passes,
		callLoginInit,
		paypalLoginInitData,
		paypalComplete,
		paypalSubmit,
		paypalSubmitData,
		getPaymentPaypalData,
		getDataPaymentPaypal,
		loading,
		getPDF,
		pdf,
		amounts,
		getAmounts,
		activatePackage,
		passesAfterActivation,
		payloadAfterLogIn,
		getVoucherPayment,
		voucherMsg,
		smsLangChange,
		receiveEmail,
		emailHasBeenSent,
		changedLang,
		errorMessageHandler,
		errorMessageHandlerVoucher,
		errorMessageHandlerCardInit,
		errorMessageHandlerPaypalInit,
		errorMessageHandlerAmounts,
		errorMessageHandlerSms,
		errorLoginHandler,
		errorActivePackage,
		errorGetPaymentData,
		errorSubmitPaypal,
		errorPaypalGetData,
		errorEmailSent,
	} = props.props;
	const [open, setOpen] = useState(false);
	const [paymentPopupConfig, setPaymentPopupConfig] = useState({
		initialStep: 0,
		initialAmount: 0,
	});
	const [openErrorPopUp, setOpenErrorPopUp] = useState(false);
	const { t } = useTranslation("common");

	useTouristDocumentTitle();

	useEffect(() => {
		const buildDate = new Date(buildInfo.buildDate);
		console.log(`Build Number: ${buildInfo.buildVersion}`);
		console.log(`Build Date: ${buildDate.toString()}`);
	}, []);

	const handleClose = () => {
		setOpen(false);
		setPaymentPopupConfig({ initialStep: 0, initialAmount: 0 });
	};

	const handleOpen = (config = {}) => {
		setPaymentPopupConfig({
			initialStep:
				typeof config.initialStep === "number" ? config.initialStep : 0,
			initialAmount:
				typeof config.initialAmount === "number" ? config.initialAmount : 0,
		});
		setOpen(true);
	};

	useEffect(() => {
		if (errorLoginHandler) {
			setOpenErrorPopUp(true);
		}
	}, [errorLoginHandler]);

	return (
		<Fragment>
			<Header
				i18n={i18n}
				t={t}
				payloadAfterLogIn={payloadAfterLogIn}
				handleOpen={handleOpen}
			/>
			<RoutedCustomCrumbs />
			<Switch>
				<Route
					path="/sms-language"
					render={(props) => (
						<SmsLang
							errorMessageHandlerSms={errorMessageHandlerSms}
							changedLang={changedLang}
							loading={loading}
							smsLangChange={smsLangChange}
							t={t}
							{...props}
						/>
					)}
				/>
				<Route
					path="/packages"
					render={(props) => (
						<Packages
							errorActivePackage={errorActivePackage}
							payloadAfterLogIn={payloadAfterLogIn}
							activatePackage={activatePackage}
							passesAfterActivation={passesAfterActivation}
							loading={loading}
							passes={passes}
							getPackageBundles={getPackageBundles}
							handleOpenPayment={handleOpen}
							t={t}
							{...props}
						/>
					)}
				/>
				<Route
					exact
					path="/"
					render={(props) => (
						<Home
							balanceUsageData={balanceUsageData}
							t={t}
							amounts={amounts}
							getAmounts={getAmounts}
							getBalanceUsage={getBalanceUsage}
							getBalanceAmount={getBalanceAmount}
							paymentInitializer={paymentInitializer}
							paymentInitData={paymentInitData}
							setOpen={setOpen}
							open={open}
							handleClose={handleClose}
							paymentSubmit={paymentSubmit}
							paymentURL={paymentURL}
							getPaymentData={getPaymentData}
							paymentDataAfterPayment={paymentDataAfterPayment}
							paypalInitData={paypalInitData}
							getPaypalInit={getPaypalInit}
							callLoginInit={callLoginInit}
							paypalLoginInitData={paypalLoginInitData}
							paypalComplete={paypalComplete}
							paypalSubmit={paypalSubmit}
							paypalSubmitData={paypalSubmitData}
							getPaymentPaypalData={getPaymentPaypalData}
							getDataPaymentPaypal={getDataPaymentPaypal}
							loading={loading}
							getPDF={getPDF}
							payloadAfterLogIn={payloadAfterLogIn}
							pdf={pdf}
							getVoucherPayment={getVoucherPayment}
							voucherMsg={voucherMsg}
							receiveEmail={receiveEmail}
							emailHasBeenSent={emailHasBeenSent}
							errorMessageHandler={errorMessageHandler}
							errorMessageHandlerVoucher={errorMessageHandlerVoucher}
							errorMessageHandlerCardInit={errorMessageHandlerCardInit}
							errorMessageHandlerPaypalInit={errorMessageHandlerPaypalInit}
							errorMessageHandlerAmounts={errorMessageHandlerAmounts}
							errorSubmitPaypal={errorSubmitPaypal}
							errorPaypalGetData={errorPaypalGetData}
							errorEmailSent={errorEmailSent}
							errorGetPaymentData={errorGetPaymentData}
							{...props}
						/>
					)}
				/>
				<Route
					type="private"
					exact
					path="/payment"
					render={(props) => (
						<PaymentReceipt
							paymentInitializer={paymentInitializer}
							paymentInitData={paymentInitData}
							t={t}
							getAmounts={getAmounts}
							amounts={amounts}
							paymentSubmit={paymentSubmit}
							paymentURL={paymentURL}
							getPaymentData={getPaymentData}
							paymentDataAfterPayment={paymentDataAfterPayment}
							paypalInitData={paypalInitData}
							getPaypalInit={getPaypalInit}
							getPDF={getPDF}
							pdf={pdf}
							getVoucherPayment={getVoucherPayment}
							voucherMsg={voucherMsg}
							receiveEmail={receiveEmail}
							emailHasBeenSent={emailHasBeenSent}
							activeStep={2}
							payloadAfterLogIn={payloadAfterLogIn}
							errorGetPaymentData={errorGetPaymentData}
							{...props}
						/>
					)}
				/>
			</Switch>
			{open ? (
				<PaymentPopUp
					paymentInitializer={paymentInitializer}
					paymentInitData={paymentInitData}
					t={t}
					getAmounts={getAmounts}
					amounts={amounts}
					setOpen={setOpen}
					open={open}
					handleClose={handleClose}
					paymentSubmit={paymentSubmit}
					paymentURL={paymentURL}
					getPaymentData={getPaymentData}
					paymentDataAfterPayment={paymentDataAfterPayment}
					paypalInitData={paypalInitData}
					getPaypalInit={getPaypalInit}
					callLoginInit={callLoginInit}
					paypalLoginInitData={paypalLoginInitData}
					paypalComplete={paypalComplete}
					paypalSubmit={paypalSubmit}
					paypalSubmitData={paypalSubmitData}
					getPaymentPaypalData={getPaymentPaypalData}
					getDataPaymentPaypal={getDataPaymentPaypal}
					loading={loading}
					getPDF={getPDF}
					pdf={pdf}
					getVoucherPayment={getVoucherPayment}
					voucherMsg={voucherMsg}
					receiveEmail={receiveEmail}
					emailHasBeenSent={emailHasBeenSent}
					errorMessageHandler={errorMessageHandler}
					errorMessageHandlerVoucher={errorMessageHandlerVoucher}
					errorMessageHandlerCardInit={errorMessageHandlerCardInit}
					errorMessageHandlerPaypalInit={errorMessageHandlerPaypalInit}
					errorMessageHandlerAmounts={errorMessageHandlerAmounts}
					errorSubmitPaypal={errorSubmitPaypal}
					errorPaypalGetData={errorPaypalGetData}
					errorEmailSent={errorEmailSent}
					initialStep={paymentPopupConfig.initialStep}
					initialAmount={paymentPopupConfig.initialAmount}
				/>
			) : null}
			{openErrorPopUp ? (
				<ErrorPopUp
					errorLoginHandler={errorLoginHandler}
					setOpenErrorPopUp={setOpenErrorPopUp}
					openErrorPopUp={openErrorPopUp}
					t={t}
					text={[
						t("errorLogInDesc"),
						t("errorLogInCookiesNote"),
						t("errorLogInCookiesDesc"),
					]}
				/>
			) : null}
			<Footer t={t} />
		</Fragment>
	);
};

export default Dashboard;
